<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Preface</a></div>
<div class="SOM_pre"><a href="#/pre3">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre4">Abbreviations</a></div>
<div class="SOM_part"><a href="#/p1">Part 1: Overview of Gender Identity in Therapy</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><b>1</b> Religious Identity and Gender Identity in Therapy</a></div>
<div class="SOM_chap"><a href="#/p1chap2"><b>2</b> Assessment</a></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><b>3</b> Discussing the Gender and Religious Identity Therapy Approach with Clients</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">Part 2: Therapy Postures and Gestures—Children</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><b>4</b> Gender Patience</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><b>5</b> Approaching Puberty: Answering Questions Around Puberty Blockers</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">Part 3: Therapy Tools—Adolescents and Adults</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><b>6</b> Adolescence: A Brief Overview</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><b>7</b> The Journey to Find “Me”</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><b>8</b> A Multitier Distinction</span></div>
<div class="SOM_chap"><span href="#/p3chap4" title="Link target outside of Sample"><b>9</b> Identifying Scripts and Storylines</span></div>
<div class="SOM_chap"><span href="#/p3chap5" title="Link target outside of Sample"><b>10</b> Chapters in One’s Life</span></div>
<div class="SOM_chap"><span href="#/p3chap6" title="Link target outside of Sample"><b>11</b> Sojourners and Traveling Companions</span></div>
<div class="SOM_chap"><span href="#/p3chap7" title="Link target outside of Sample"><b>12</b> Unpacking Feelings</span></div>
<div class="SOM_chap"><span href="#/p3chap8" title="Link target outside of Sample"><b>13</b> Where Is God?</span></div>
<div class="SOM_chap"><span href="#/p3chap9" title="Link target outside of Sample"><b>14</b> Coping and Management Strategies</span></div>
<div class="SOM_part"><span href="#/p4" title="Link target outside of Sample">Part 4: Case Studies</span></div>
<div class="SOM_chap"><span href="#/p4chap1" title="Link target outside of Sample"><b>15</b> Individual: The Case of Kelly</span></div>
<div class="SOM_chap"><span href="#/p4chap2" title="Link target outside of Sample"><b>16</b> Couples Therapy: The Case of Ben (Bea) and Elodie</span></div>
<div class="SOM_chap"><span href="#/p4chap3" title="Link target outside of Sample"><b>17</b> Individual Therapy: The Case of Rae</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">References</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Index</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Praise for <i>Gender Identity and Faith</i></span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">About the Authors</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?ece373ba